import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { 
  Container,
  Grid,
  Card,
  CardMedia,
  CardContent,
  Typography,
  Modal,
  IconButton,
  Box,
  Fade,
  Paper
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ZoomInIcon from '@mui/icons-material/ZoomIn';

const Photos = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  // Sample images array - replace with your image paths
  const images = [
    {
      id: 1,
      url: '/Events/img-1.jpg',
      title: 'Nature View',
      description: 'Beautiful landscape photography'
    },
    {
        id: 2,
        url: '/Events/img-2.jpg',
        title: 'Nature View',
        description: 'Beautiful landscape photography'
      },
      {
        id: 3,
        url: '/Events/img-3.jpg',
        title: 'Nature View',
        description: 'Beautiful landscape photography'
      },
      {
        id: 4,
        url: '/Events/img-4.jpg',
        title: 'Nature View',
        description: 'Beautiful landscape photography'
      },
      {
        id: 5,
        url: '/Events/img-5.jpg',
        title: 'Nature View',
        description: 'Beautiful landscape photography'
      },
      {
        id: 6,
        url: '/Events/img-6.jpg',
        title: 'Nature View',
        description: 'Beautiful landscape photography'
      },
      {
        id: 7,
        url: '/Events/img-17.jpg',
        title: 'Nature View',
        description: 'Beautiful landscape photography'
      },
      {
        id: 8,
        url: '/Events/img-18.jpg',
        title: 'Nature View',
        description: 'Beautiful landscape photography'
      },
      {
        id: 9,
        url: '/Events/img-19.jpg',
        title: 'Nature View',
        description: 'Beautiful landscape photography'
      },
      {
        id: 10,
        url: '/Events/img-10.jpg',
        title: 'Nature View',
        description: 'Beautiful landscape photography'
      },
      {
        id: 11,
        url: '/Events/img-11.jpg',
        title: 'Nature View',
        description: 'Beautiful landscape photography'
      },
      {
        id: 12,
        url: '/Events/img-12.jpg',
        title: 'Nature View',
        description: 'Beautiful landscape photography'
      },
      {
        id: 13,
        url: '/Events/img-13.jpg',
        title: 'Nature View',
        description: 'Beautiful landscape photography'
      },
      {
        id: 14,
        url: '/Events/img-14.jpg',
        title: 'Nature View',
        description: 'Beautiful landscape photography'
      },
      {
        id: 15,
        url: '/Events/img-15.jpg',
        title: 'Nature View',
        description: 'Beautiful landscape photography'
      },
      {
        id: 16,
        url: '/Events/img-16.jpg',
        title: 'Nature View',
        description: 'Beautiful landscape photography'
      },
      {
        id: 17,
        url: '/Events/img-7.jpg',
        title: 'Nature View',
        description: 'Beautiful landscape photography'
      },
      {
        id: 18,
        url: '/Events/img-8.jpg',
        title: 'Nature View',
        description: 'Beautiful landscape photography'
      },
      {
        id: 19,
        url: '/Events/img-9.jpg',
        title: 'Nature View',
        description: 'Beautiful landscape photography'
      },
      {
        id: 20,
        url: '/Events/img-20.jpg',
        title: 'Nature View',
        description: 'Beautiful landscape photography'
      },
      {
        id: 21,
        url: '/Gallery/img-25.jpg',
        title: 'Nature View',
        description: 'Beautiful landscape photography',
      },
      {
        id:22,
        url: '/Gallery/img-26.jpg',
        title:"Natural View",
        description:"Beautiful landscape Photography"
      }

      
    // Add more images as needed
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };

  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <Typography 
          variant="h2" 
          align="center"
          sx={{
            mb: 6,
            fontWeight: 'bold',
            background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
            backgroundClip: 'text',
            textFillColor: 'transparent',
            textShadow: '2px 2px 4px rgba(0,0,0,0.1)'
          }}
        >
          Photo Gallery
        </Typography>
      </motion.div>

      <motion.div
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        <Grid container spacing={3}>
          {images.map((image) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={image.id}>
              <motion.div variants={itemVariants}>
                <Card 
                  sx={{ 
                    position: 'relative',
                    transition: '0.3s',
                    '&:hover': {
                      transform: 'scale(1.03)',
                      boxShadow: '0 8px 16px rgba(0,0,0,0.2)'
                    }
                  }}
                  onClick={() => setSelectedImage(image)}
                >
                  <CardMedia
                    component="img"
                    height="280"
                    image={image.url}
                    alt={image.title}
                    sx={{ cursor: 'pointer' }}
                    onClick={() => setSelectedImage(image)}
                  />
                  <Box
                    sx={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                      bgcolor: 'rgba(0,0,0,0.4)',
                      opacity: 0,
                      transition: '0.3s',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      '&:hover': {
                        opacity: 1
                      }
                    }}
                  >
                    <IconButton
                      sx={{ color: 'white' }}
                      onClick={() => setSelectedImage(image)}
                    >
                      <ZoomInIcon sx={{ fontSize: 40 }} />
                    </IconButton>
                  </Box>
                  {/* <CardContent>
                    <Typography variant="h6" gutterBottom>
                      {image.title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {image.description}
                    </Typography>
                  </CardContent> */}
                </Card>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </motion.div>

      <Modal
        open={!!selectedImage}
        onClose={() => setSelectedImage(null)}
        closeAfterTransition
      >
        <Fade in={!!selectedImage}>
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              maxWidth: '90vw',
              maxHeight: '90vh',
              outline: 'none'
            }}
          >
            <Paper elevation={24}>
              <Box sx={{ position: 'relative' }}>
                <IconButton
                  sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: 'white',
                    bgcolor: 'rgba(0,0,0,0.5)',
                    '&:hover': {
                      bgcolor: 'rgba(0,0,0,0.7)'
                    }
                  }}
                  onClick={() => setSelectedImage(null)}
                >
                  <CloseIcon />
                </IconButton>
                <img
                  src={selectedImage?.url}
                  alt={selectedImage?.title}
                  style={{
                    maxWidth: '90vw',
                    maxHeight: '90vh',
                    display: 'block'
                  }}
                />
              </Box>
            </Paper>
          </Box>
        </Fade>
      </Modal>
    </Container>
  );
};

export default Photos;